let woocommerceAffirm = {
    $affirmAsLowAs: undefined,
    $affirmOfferDisclaimer: undefined,
    $affirmObserver: undefined,

    affirmPromoMessage(observer) {
        if ( woocommerceAffirm.$affirmAsLowAs.length ) {
            // Override Affirm's default "-" text in the DOM
            if ( woocommerceAffirm.$affirmAsLowAs.text() === '-' ) {
                woocommerceAffirm.$affirmAsLowAs.text("");
            }

            // Target Affirm promo message node for observation
            var targetNode = woocommerceAffirm.$affirmAsLowAs[0];

            // Set options for the observer
            var config = { childList: true };

            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }
    },

    affirmObserverInit() {
        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
            mutationsList.forEach(function (mutation) {
                if ( mutation.type == "childList" ) {
                    // Check for disclaimer in DOM, if disclaimer doen't exist then add it
                    if ( !woocommerceAffirm.$affirmOfferDisclaimer.length ) {
                        jQuery("<p class='affirm-offer-disclaimer text-sm italic'>*Minimum pre-tax purchase of $800 to qualify</p>")
                            .insertAfter(".affirm-as-low-as");
                    }
                }
            });
        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        return observer;
    }
};

export default function () {
    woocommerceAffirm.$affirmAsLowAs = jQuery(".affirm-as-low-as");
    woocommerceAffirm.$affirmOfferDisclaimer = jQuery(".affirm-offer-disclaimer");
    woocommerceAffirm.$affirmObserver = woocommerceAffirm.affirmObserverInit();

    $(document).ready(function() {
        woocommerceAffirm.affirmPromoMessage(woocommerceAffirm.$affirmObserver);
    });
}
